import Api, { PerformerRequest } from '@silbo/core';

export const getRequestQuery = (id: string) =>
  new Api.Query(PerformerRequest)
    .equalTo('objectId', id)
    .include([
      'request',
      'request.visit',
      'request.visit.thesaurusItem',
      'request.originAccommodation.unit',
      'request.originAccommodation.bed',
      'request.originAccommodation.responsibleUnit',
      'performer',
    ]);
